/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/

/**
* `dashboard-landing` landing page of dashboard
* 
 * This component does below functionalities:
*  1. Does all api calls to get response required for components of dashboard
*  2. Also it act as a container to all other required component of dashboard
*/

//import './recent-transaction.js';
import './dashboard-quick-links.js';
import './dashboard-user-actions.js';
import './dashboard-recent-transactions.js';
import './dashboard-user-offers.js';
import './relevant-transaction.js';
import './dashboard-portfolio.js';
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
import '@polymer/iron-collapse/iron-collapse.js'

const template = html`
        <style include="app-styles">
            .dashboard-paper-card-height {
                height: 270px;
                overflow-y: auto;
                overflow-x: hidden;
            }

            .dashboard-paper-card-height::-webkit-scrollbar-track {
                background: var(--primary-light-color);
            }

            .dashboard-paper-card-height[phone] {
                height: auto;
                overflow-y: auto;
            }

            .dashboard-paper-card-height[showscrollactions]::-webkit-scrollbar-track,
            .dashboard-paper-card-height[showscrollinfo]::-webkit-scrollbar-track {
                border: 8px solid transparent;
                background: var(--divider-color);
                background-clip: content-box;
            }

            /*recent transaction*/

            .dashboard-paper-card-recent, .portfolio-wrapper {
                height: 260px;
                overflow-y: auto;
                overflow-x:hidden;
            }

            .portfolio-wrapper[desktop] {
                height: 310px;
            }
            
            .dashboard-paper-card-recent.recent-trans {
                overflow: unset;
            }

            .dashboard-paper-card-recent::-webkit-scrollbar-track {
                background: var(--primary-light-color);
            }

            .dashboard-paper-card-recent[phone] {
                height: auto !important;
                overflow-y: auto !important;
            }

            .dashboard-paper-card-recent[noinfo],
            .dashboard-paper-card-recent[noactions] {
                height: 270px;
                overflow-y: scroll;
            }

            .dashboard-paper-card-recent[noinfo]::-webkit-scrollbar-track,
            .dashboard-paper-card-recent[noactions]::-webkit-scrollbar-track {
                border: 8px solid transparent;
                background: var(--divider-color);
                background-clip: content-box;
            }

            /*offers*/

            .dashboard-paper-card-offers[offersAvailable] {
                @apply --layout-horizontal;
                @apply --layout-center;
                @apply --layout-center-justified;
            }

            .dashboard-paper-card[phone] {
                background: var(--primary-light-color) !important;
                overflow-x:hidden;
                overflow-y:hidden;               
                box-shadow: 0px 0px 0px 0px !important;
                position: relative;
            }

            ::-webkit-scrollbar {
                width: 17px;
            }

            /* Customize Thumb */

            ::-webkit-scrollbar-thumb {
                background: var(--elevation-color);
                border-radius: 10px;
                border: 6px solid transparent;
                background-clip: content-box;
            }

            /* Customize Track */

            ::-webkit-scrollbar-track {
                border: 8px solid transparent;
                background: var(--divider-color);
                background-clip: content-box;
            }
            .invalidLoginImg {
                margin: 30px;
                height: 40%;
                min-height: 150px;
                min-width: 150px;
            }
              .padding-bottom-10{
                padding-bottom:10%;
              }

            .quickcard-innerheight{
              height:auto;
            }
              
            app-dialog#stoppaymentauthorizeelemdia {
			      	--app-dialog-min-height: 150px
			      }

            app-dialog {
                --dialog-background-color: {
                    background-color: var(--brand-color);
                }
                --dialog-text-color: {
                    color: var(--background-primary);
                }
                --outline-offset-close: {
                  outline:2px solid rgba(0,0,0,0.87);
                }
            }

            .iron-collapse-icon {
                transition: transform .2s;
                -webkit-transition: -webkit-transform .2s;
                -moz-transition: -moz-transform .2s;
                -ms-transition: -ms-transform .2s;
                -o-transition: -o-transform .2s;
                transform: rotate(-90deg);
                -webkit-transform: rotate(-90deg);
                -moz-transform: rotate(-90deg);
                -o-transform: rotate(-90deg);
            }

            .iron-collapse-open {
                transform: rotate(90deg);
                -webkit-transform: rotate(90deg);
                -moz-transform: rotate(90deg);
                -o-transform: rotate(90deg);
            }
            .promo-banner {
                width: 210px;
                height: 310px;
            }

            .top-container {
                width: calc(100% - 210px);
            }

            .promotion-banner-container {
                width: calc(100% - 222px);
            }
            
            .bannerSecondaryImg{
                width: calc(100% - 16px);
                height: 73px;
                margin: auto;
                border-radius: 5px;
            }
            @media (max-width:479px){
              .quickcard-height {
               height:110% !important;
             } 
           } 
   
        </style>

        <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
        <oe-ajax id="refNtwkfetch" auto content-type="application/json" handle-as="json" url="/api/codereferences?filter[where][codeType]=CTAT"
		        method="get" last-response="{{ntwklist}}" on-error="showGetError"></oe-ajax>  
        <page-title name="{{titlePage}}" contextual-menu="{{contextualMenu}}" paper-toolbar-text-color="{{paperToolbarTextColor}}"
         paper-toolbar-back-color="{{paperToolbarBackColor}}" name-from-literal={{nameFromLiteral}}></page-title>

        <app-data app-data="{{appData}}"></app-data>

        <div class="mdl-grid mdl-grid--no-spacing">

            <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col--tablet mdl-cell--12-col">
                <div class="mdl-grid padding-b-zero" hidden$="{{!phone}}"></div>

                <div class$="{{_applyClassBasedOnDevice(phone)}}">
                    <div class="display-flex full-width">
                        <div class$="margin-zero mdl-grid padding-zero top-container {{_getContainerClass(phone)}}" phone$="{{phone}}">
                            <!-- my portfolio -->
                            <paper-card class="elevation-2 margin-t-zero mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col overflow-hidden"
                            elevation="0">
                                
                                <div class="dashboard-paper-card portfolio-wrapper full-height" id="relevent_transaction_scollDiv" desktop$="{{desktop}}" phone$="{{phone}}">
                                    <dashboard-portfolio id="dashport" err-message={{errMessage}} show-nodata-fetch-msg={{showNodataFetchMsg}} no-details-flag={{noDetailsFlag}} account-response="{{accountResponse}}" ></dashboard-portfolio>
                                </div>
                                <div class="mdl-grid padding-b-zero" hidden$="{{!phone}}"></div>
                            </paper-card>
                            <!-- my portfolio -->

                            <div class="mdl-grid padding-b-zero" hidden$="{{!phone}}"></div>

                            <!-- Recent Transactions -->
                            <template is="dom-if" if="{{!phone}}" restamp>
                            <paper-card hidden$="{{phone}}" class="elevation-2 margin-t-zero mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col overflow-hidden" hidden$={{!transactionsAvailable}}
                            elevation="0">
                                <div class="dashboard-paper-card" noinfo$={{!userInformationAvailable}} noactions$={{!userActionsAvailable}}
                                phone$="{{phone}}" id="recent_transaction_scollDiv">
                                    <dashboard-recent-transactions  tempobj={{tempobj}}  opr-acc-list={{oprAccList}}  savings={{savings}} cards={{cards}} transactions-available={{transactionsAvailable}}>
                                    </dashboard-recent-transactions>
                                </div>
                            </paper-card>
                            </template>
                            <!-- Recent Transactions -->
                        </div>
                        <paper-card class="elevation-2 margin-t-zero mdl-cell promo-banner" elevation="0" hidden$="{{phone}}">
                            <div class="outlineOffset font-size-m" role="link" tabindex="0">
                                <img src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/dashbord_banners/Banner1.png" class="outlineOffset full-width full-height cursor-pointer" alt="banner1Image" on-tap="CallChildEvent" tabindex="0">
                            </div>
                        </paper-card>
                    </div>
                    <div class="padding-b-zero" hidden$="{{!phone}}"></div>

                    <!-- User actions -->
                    <paper-card class="elevation-2 mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--12-col overflow-hidden" hidden$={{!userActionsAvailable}}
                     elevation="0">
                       
                        <div class="dashboard-paper-card" id="dashboard_user_actions_scollDiv" showscrollactions$={{showScrollActions}}
                         phone$="{{phone}}">
                            <dashboard-user-actions payment-approval={{paymentApproval}} loans={{loans}} bills={{bills}} cards={{cards}} billers={{billers}} user-actions-available={{userActionsAvailable}}
                             user-actions-loader={{userActionsLoader}} no-details-flag={{noDetailsFlag}} loans-with-all-accounts={{loansWithAllAccounts}}></dashboard-user-actions>
                        </div>
                    </paper-card>
                    <!-- User actions -->

                    <div class="mdl-grid padding-b-zero" hidden$="{{!phone}}"></div>
                    <div class="display-flex full-width">
                        <div class$="margin-zero mdl-grid padding-zero top-container {{_getContainerClass(phone)}}" phone$="{{phone}}">
                        <template is="dom-if" if="{{phone}}">
                            <!-- Recent Transactions -->
                            <paper-card hidden$="{{!phone}}" class="elevation-2 border-b-1px margin-t-zero mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col overflow-hidden" hidden$={{!transactionsAvailable}}
                            elevation="0">
                                <div class="dashboard-paper-card" noinfo$={{!userInformationAvailable}} noactions$={{!userActionsAvailable}}
                                phone$="{{phone}}" id="recent_transaction_scollDiv">
                                    <dashboard-recent-transactions tempobj={{tempobj}} savings={{savings}} opr-acc-list={{oprAccList}} cards={{cards}} transactions-available={{transactionsAvailable}}>
                                    </dashboard-recent-transactions>
                                </div>
                            </paper-card>
                        </template>
                            <!-- Recent Transactions -->
                            <paper-card class="border-b-1px elevation-2 mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col overflow-hidden"
                            elevation="0">
                                <div class="outlineOffset content-align-vertical-center justify-content-space-bwn mdl-grid" on-tap="_toggleIronCollapse" tabindex="0">
                                    <div class="font-medium margin-zero mdl-grid primary-dark-text-m padding-b-zero outlineOffset" role="heading" level="2" tabindex="0">
                                        <oe-i18n-msg msgid="h_frequentMenuItems"></oe-i18n-msg>
                                        <div class="mdl-grid full-width padding-b-zero" hidden$="{{!phone}}"></div>
                                    </div>
                                    <iron-icon id="ironCollapseIcon" icon="chevron-left" class="iron-collapse-icon" hidden$="{{!phone}}">
                                    </iron-icon>
                                </div>
                                <iron-collapse id="relevantTransactions" opened="{{ironCollapseState}}">
                                    <div class="dashboard-paper-card dashboard-paper-card-recent" id="relevent_transaction_scollDiv" phone$="{{phone}}">
                                        <relevant-transaction data={{data}}></relevant-transaction>
                                    </div>
                                </iron-collapse>
                            </paper-card>
                        
                            <!-- </template> -->
                            <paper-card class="border-b-1px elevation-2 mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col overflow-hidden"
                                elevation="0" >
                                    <div class="outlineOffset content-align-vertical-center justify-content-space-bwn mdl-grid" on-tap="_toggleIronCollapse_Ql" tabindex="0">
                                        <div class="font-medium margin-zero mdl-grid primary-dark-text-m outlineOffset" role="heading" level="2" tabindex="0">
                                            <oe-i18n-msg msgid="Quick Links"></oe-i18n-msg>
                                        </div>
                                        <iron-icon id="ironCollapseIcon_Ql" icon="chevron-left" class="iron-collapse-icon" hidden$="{{!phone}}">
                                        </iron-icon>
                                    </div>
                                    <iron-collapse id="relevantTransactions_Ql" opened="{{ironCollapseState_Ql}}">
                                        <div class="dashboard-paper-card dashboard-paper-card-recent" id="relevent_transaction_scollDiv" phone$="{{phone}}">
                                            <dashboard-quick-links></dashboard-quick-links>
                                        </div>
                                    </iron-collapse>
                            </paper-card>
                        </div>
                        <paper-card class="elevation-2 mdl-cell promo-banner"
                        elevation="0" hidden$="{{phone}}">
                            <div class="outlineOffset font-size-m" role="link" tabindex="0" on-tap="CallDirectBank">
                                <img src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/dashbord_banners/Banner2.png" class="full-width full-height cursor-pointer" alt="banner2Image">
                            </div>
                        </paper-card>
                    </div>
                   
                    
                    <div class="mdl-grid padding-b-zero" hidden$="{{!phone}}"></div>
                     <!-- card for the Ticker Messages-->        
                    <div class$="margin-zero mdl-grid padding-zero promotion-banner-container {{_getContainerClass(phone)}}" phone$="{{phone}}">
                        <paper-card class="elevation-2 mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col overflow-hidden quickcard-height" 
                                    elevation="0">
                            <div class="dashboard-paper-card dashboard-paper-card-recent quickcard-innerheight" phone$="{{phone}}" id="ticker_message_scollDiv">
                                <view-ticker-messages-carousel   ticker-message-list={{tickerMessageList}} ticker-message-list-available={{tickerMessageListAvailable}}></view-ticker-messages-carousel>
                            </div>
                        </paper-card>
                        <template is="dom-if" if="{{!phone}}">
                            <paper-card class="mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col dashboard-paper-card dashboard-paper-card-offers"
                            phone$="{{phone}}" offersAvailable$="{{offersAvailable}}" hidden$={{!offersAvailable}} elevation="0">
                                <div tabindex=0 role="region" aria-label$="{{getLabel('h_AdvertisingRegion')}}" class="outlineOffset">
                                    <dashboard-user-offers offers={{offers}} offers-available={{offersAvailable}}></dashboard-user-offers>
                                </div>
                            </paper-card>
                        </template>
                    </div>  
                    
                </div>

            </div>

        </div>

        <app-dialog name="{{getLabel('h_chooseFinancialAddressType')}}" aria-label$="{{getLabel('h_groupTag')}}" id="adhocPaymentType" elementid="paymentType">
				<div class="mdl-grid" role="listbox">
				
            <template is="dom-repeat" items="{{ntwklist}}" as="categoryItem">
							<div role="option" on-focus="_onFocusIn" on-focusout="_onFocusOut" aria-selected$="{{categoryItem.ariaSelected}}" tabindex=0 on-keydown="goToAdhocPaymentDDA" class="outlineOffset margin-top-conatiner chips-option-unSelected" id="categoryitemIndex_{{index}}" on-tap="goToAdhocPayment">{{categoryItem.codeDescription}}</div>
				</template>
				</div>

			</app-dialog>
        
        <app-dialog id="invalidLogin" elementid="invalidLoginEl">
            <div class="mdl-cell mdl-cell--12-col primary-dark-text-m font-medium margin-zero">
                <oe-i18n-msg msgid='l_RecentInvalidLoginAttempt'></oe-i18n-msg>

            </div>
            <p class="mdl-cell mdl-cell--12-col secondary-dark-text-m font-medium margin-zero"> at {{invalidDate}}</p>

            <img class="invalidLoginImg" alt="invalid image" src="{{invalidImgSrc}}">
        </app-dialog>`;
Polymer({
    is: 'dashboard-landing',
    _template: template,
    behaviors: [accessibilityBehaviours.commonFunctions],
    properties: {
        imageBaseUrl: {
            type: String,
            value: window.OEUtils.uibaseroute
        },
        tenantId: {
            type: String,
            value: sessionStorage.getItem("tenantId")
        },
        /*User ID*/
        userId: {
            type: String
        },
        /*List of saving accounts*/
        savings: {
            type: Array
        },
    oprAccList: {
      type: Array,
      notify: true
    },
        /*List of credit cards*/
        cards: {
            type: Array
        },
        /*List of loan accounts*/
        loans: {
            type: Array
        },
        /*List of deposit accounts*/
        investments: {
            type: Array
        },
        /*List of bills*/
        bills: {
            type: Array
        },
        /*List of billers*/
        billers: {
            type: Array
        },
        /*List of approvals for payment*/
        paymentApproval: {
            type: Array
        },
        /* Flag to check transactions available or not*/
        transactionsAvailable: {
            type: Boolean,
            value: true
        },
        /* Flag to check actions available or not*/
        userActionsAvailable: {
            type: Boolean,
            value: true
        },
        /* Flag to check user informations available or not*/
        userInformationAvailable: {
            type: Boolean,
            value: true
        },
        /*List of offers*/
        offers: {
            type: Array
        },
        /*Flag for checking offers available or not*/
        offersAvailable: {
            type: Boolean,
            value: true
        },
        /*List Active Status code for saving accounts*/
        activeSavingAccountStatus: {
            type: Array,
            value: ['A', '001' , 'M']
        },
        /*List Active Status code for loan accounts*/
        activeLoanAccountStatus: {
            type: Array,
            value: ['001', 'A', 'O']
        },
        /*List Active Status code for deposit accounts*/
        activeDepositAccountStatus: {
            type: Array,
            value: ['A', '001']
        },
        /*List Active Status code for cards*/
        activeCardAccountStatus: {
            type: Array,
            value: ['001', 'A']
        },
        /*List of saving accounts with closed also*/
        savingsWithAllAccounts: {
            type: Array
        },
        /*List of credit cards with closed also*/
        cardsWithAllAccounts: {
            type: Array
        },
        /*List of loan accounts with closed also*/
        loansWithAllAccounts: {
            type: Array
        },
        /*List of investment accounts with closed also*/
        investmentsWithAllAccounts: {
            type: Array
        },
        /*Flag to show my wall component loader*/
        userInformationLoader: {
            type: Boolean,
            value: true,
            observer: '_infoLoaderChanged'
        },
        /*Flag to show my actions component loader*/
        userActionsLoader: {
            type: Boolean,
            value: true,
            observer: '_actionsLoaderChanged'
        },
        /*Flag to show scroll Info*/
        showScrollInfo: {
            type: Boolean,
            value: false
        },
        /*Flag to show scroll actions*/
        showScrollActions: {
            type: Boolean,
            value: false
        },
        /*Speedboat global storage*/
        appData: {
            type: Object,
            value: {}
        },
        invalidImgSrc: {
            type: String
        },
        invalidDate: {
            type: String
        },
        /*getting list of bonds*/
        bonds: {
            type: Array,
            observer: 'handleBonds'
        },

        /*getting sum of bonds*/
        totalBonds: {
            type: String
        },

        /* List of Ticker Messages and links*/
        tickerMessageList: {
            type: Array,
            value: []
        },

        /* Flag For tickerMessage list availble or not*/
        tickerMessageListAvailable: {
            type: Boolean,
            value: false
        },
        ironCollapseState: {
            type: Boolean,
            value: false,
            notify: true
        },
    tempobj: {
      type: Object,
      notify: true
    },
    noDetailsFlag: {
      type: Boolean,
      notify: true,
      value:false
    },
    ironCollapseState_Ql: {
      type: Boolean,
      value: false,
      notify: true
    },
    accountResponse: {
      type: Array,
      notify: true
    },
    showRecentTransactionMsgFlag: {
      type: Boolean,
      notify: true
    },
    recentTransactionLoaderFlag: {
      type: Boolean,
      notify: true
    },
    oprAccountList: {
      type: Array,
      notify: true
    },
    showNodataFetchMsg: {
      type: Boolean,
      notify: true
    },
    errMessage: {
      type: String,
      notify: true
    }
  },

    /* Observer which get trigger based in loader flag of my walk */
    // _infoLoaderChanged: function () {
    //     if (this.userInformationAvailable) if (this.$$('#dashboard_user_info_scollDiv').scrollHeight > 270) this.showScrollInfo = true;
    // },

    /* Observer which get trigger based in loader flag of my actions */
    _actionsLoaderChanged: function () {
        if (this.userActionsAvailable) if (this.$$('#dashboard_user_actions_scollDiv').scrollHeight > 270) this.showScrollActions = true;
    },


    _getContainerClass: function(phone) {
        return phone ? 'full-width mdl-grid--no-spacing' : '';
    },
    /* Function for changing styles */
    _applyClassBasedOnDevice: function (phone) {
        if (phone) return "mdl-grid mdl-grid--no-spacing";
        return "mdl-grid padding-t-zero";
    },

    _toggleIronCollapse: function () {
        if (this.phone) {
            this.$.relevantTransactions.toggle();
            if (this.ironCollapseState) {
                this.$.ironCollapseIcon.classList.add('iron-collapse-open');
            } else {
                this.$.ironCollapseIcon.classList.remove('iron-collapse-open');
            }
        }
    },
    _toggleIronCollapse_Ql: function () {
        if (this.phone) {
            this.$.relevantTransactions_Ql.toggle();
            if (this.ironCollapseState_Ql) {
                this.$.ironCollapseIcon_Ql.classList.add('iron-collapse-open');
            } else {
                this.$.ironCollapseIcon_Ql.classList.remove('iron-collapse-open');
            }
        }
    },

    /* Polymer lifecycle function for initiating private function */
    ready: function () {
        window.timeConstants = {};
        timeConstants.pageAnimate = "700";
        timeConstants.clearTransition = "1000";
        this.userId = clientStorage.get(storageType.session, "userId");
    // var ajaxCall = document.createElement('oe-ajax');
    // ajaxCall.contentType = "application/json";
    // ajaxCall.handleAs = "json"; // API to fetch accounts list to show in dropdown

    // ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/operativeaccounts';
    // ajaxCall.method = 'get';
    // ajaxCall.addEventListener('response', function (event) {
      // Dirty checking array for dom-repeat
      // var tempAccList = _.cloneDeep(event.detail.response);

      //    this.oprAccList = [];
      // this.oprAccList = tempAccList;

      // if (this.oprAccountList.length === 0) {
      //   this.noAccountsList = true;
      //    this.showRecentTransactionMsg = true;
      //  } else {
      //    this.noAccountsList = false;
      //    this.selectedAccount = this.oprAccountList[0];
      //   }

      // tempAccList = null;
      // }.bind(this));
      // ajaxCall.addEventListener('error', function (event) {
      // console.log(event.detail.error);
      // this.tempobj = {

        // showRecentTransactionMsgFlag: true,

        // recentTransactionLoaderFlag: false

      // }


      // this.noDetailsFlag = true;
      // const url = event.currentTarget.url;
      // this.userActionsLoader = false;

      // if (url.includes('/bills')) {
      //   self.bills = [];
      // }
      // var self = this;
      // var modelAPI = 'operativeAccounts';
      // this.serviceError(event, modelAPI);
    // }.bind(this));
    // oeAjaxEventListner(ajaxCall);
    // ajaxCall.generateRequest();
    this._fadeOutInvoke();

    this._getAjaxBondServiceCall('/investmentsaccounts/bonds/holdings');

    this.handleInvalidLogin();

    if (window.webpackEnabled) {
      var eleSelect = document.querySelector('sb-app-route');
    } else {
      var eleSelect = document.querySelector('oe-app-route');
    }

    if (typeof routerPolicy != "undefined" && routerPolicy.loadWebView) {
      routerPolicy.loadWebView({
        data: 'true'
      }, function (e) {}, function (e) {});
    } // if(!this.phone) {
    // this.$.relevantTransactions.show();
    // }


    this.ironCollapseState = !this.phone;
    this.ironCollapseState_Ql = !this.phone;

    if (eleSelect) {
      eleSelect.addEventListener('oe-route-change', function () {
        var divScrollTop = document.getElementById('maincontent');
        divScrollTop.scrollTop = 0;
        document.querySelector('iron-pages').addEventListener('iron-select', function () {
          var divScrollTop = document.getElementById('maincontent');
          divScrollTop.scrollTop = 0;
        });
      });
    }
    /* Generic function for handling ajax call response*/


    this._filterResponse = function (modelAPI, list, self) {
      switch (modelAPI) {
        case "accounts":
          self.accountResponse = list;
          var accOPR = [];
          var accLON = [];
          var accDEP = [];
          var accCCD = [];

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].parentAccountType.cmCode === "OPR") accOPR.push(list[i]); else if (list[i].parentAccountType.cmCode === "LON") accLON.push(list[i]); else if (list[i].parentAccountType.cmCode === "DEP") accDEP.push(list[i]); else if (list[i].parentAccountType.cmCode === "CCD") accCCD.push(list[i]);
                    }
                    /* Saving Account */
                    self.savingsWithAllAccounts = accOPR;
                    clientStorage.set(storageType.session, 'operativeAccountList', self.savingsWithAllAccounts);
                    this.dispatchEvent(new CustomEvent('operative-accounts-received', {
                        bubbles: true,
                        composed: true
                    }));
                    self.appData.savings = accOPR;
                    self._createSavingsList(self.savingsWithAllAccounts);

                    self.loansWithAllAccounts = accLON;
                    self.appData.loans = accLON;
                    self._createLoansList(self.loansWithAllAccounts);

                    self.investmentsWithAllAccounts = accDEP;
                    self.appData.investments = accDEP;
                    self._createInvestmentsList(self.investmentsWithAllAccounts);

                    self.cardsWithAllAccounts = accCCD;
                    self.appData.cards = accCCD;
                    self._createCardsList(self.cardsWithAllAccounts);

                    this._getAjaxServiceCall('preferences');

                    break;

                case "bills":
                    self.bills = list;
                    break;

                case "billers":
                    self.billers = list;
                    document.getElementById("page-title-label").appData.billerList = self.billers
                    break;

                case "transactionsrequests-approvals?filter[where][transactionStatus]=PMA":
                    self.paymentApproval = list;
                    break;

                case "userpreference":
                    clientStorage.set(storageType.session, 'userpreference', event.detail.response);
                    self.fire('userpreference-changed-side-nav', event.detail.response);
                    self.fire('userpreference-changed-header-panel', event.detail.response);
                    break;

                case "preferences":
                    clientStorage.set(storageType.session, 'preferences', list);
                if (list.primaryAccountNumber != undefined) {
                    if (list.primaryAccountNumber.cmCode) {
                        this.primaryAccountObj = _.find(self.savingsWithAllAccounts, {
                            "accountId": list.primaryAccountNumber.cmCode
                        });
                    } else {
                        this.primaryAccountObj = _.find(self.savingsWithAllAccounts, {
                            "accountId": self.savingsWithAllAccounts[0].accountId
                        });
                    }

                    if (!_.isEmpty(this.primaryAccountObj)) {
                        clientStorage.set(storageType.session, 'primaryAccount', this.primaryAccountObj);
                    }
                }
            }
        },
            /* Generic function for doing ajax call */
            this._getAjaxServiceCall = function (modelAPI) {
                var ajaxCall = document.createElement('oe-ajax');
                var self = this;
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/CBUsers/" + self.userId + "/" + modelAPI;
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function (event) {
                    const apiUrl = modelAPI.includes('bills') ? 'bills' : modelAPI;
                    self._filterResponse(apiUrl, event.detail.response, self);
                });
                ajaxCall.addEventListener("error", function (e) {
                    const url = e.currentTarget.url;
                    if(url.includes('/bills')) {
                        self.bills = [];
                    }
                    self.serviceError(e, modelAPI);
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            },
            this._getAjaxServiceCall('accounts');
            /* For getting offers */
            this._getOffersCall = function () {
                var self = this;
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/Offers";
                ajaxCall.method = "get";
                ajaxCall.addEventListener('response', function (event) {
                    self.offers = event.detail.response;
                });
                ajaxCall.addEventListener('error', function (e) {
                    self.serviceError(e, 'offers');
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            };
    },
    /* persistant menu navigation Changes */
    CallChildEvent: function(){
        this.$.dashport._navigateToCard();
    },
    CallDirectBank: function(){
        this.$.dashport.createLoanAccountDIB();
    },
    _fadeOutInvoke: function () {
        document.getElementById("opacity-screen").classList.remove("p-fade-out", "p-fade-in");
        document.getElementById("opacity-screen").classList.add("show", "p-fade-out");
        setTimeout(this._reomveTransitionClass, window.timeConstants.clearTransition);
    },
    _reomveTransitionClass: function () {
        document.getElementById("opacity-screen").classList.remove("show", "p-fade-out", "p-fade-in");
    },
    /* For handling invalid logins */
    handleInvalidLogin: function () {
        if (window.device && isDevMode()) {
            var self = this;
            var fetchInvalidDetails = document.createElement('oe-ajax');
            fetchInvalidDetails.contentType = "application/json";
            fetchInvalidDetails.handleAs = "json";
            fetchInvalidDetails.url = '/api/InvalidLogins/' + window.device.uuid;
            fetchInvalidDetails.method = 'GET';
            oeAjaxEventListner(fetchInvalidDetails);
            fetchInvalidDetails.generateRequest();
            fetchInvalidDetails.addEventListener('response', function (event) {
                var response = event.detail.response;

                if (response.showDetails === true) {
                    self.invalidImgSrc = response.photo;
                    self.invalidDate = response.date;
                    self.shadowRoot.querySelector("#invalidLogin").shadowRoot.querySelector("#invalidLoginEl").open();
                    var ajaxPost = document.createElement("oe-ajax");
                    ajaxPost.contentType = "application/json";
                    ajaxPost.handleAs = "json";
                    ajaxPost.url = '/api/InvalidLogins/';
                    ajaxPost.method = "PUT";
                    ajaxPost.body = {
                        "deviceId": window.device.uuid,
                        "showDetails": false,
                        "userId": clientStorage.get(storageType.session, "userId")
                    };
                    oeAjaxEventListner(ajaxPost);
                    ajaxPost.generateRequest(); //update showDetails to false
                }
            });
        }
    },
    /* Polymer lifecycle function - for initiating required api calls */
    attached: function () {
        this.userId = clientStorage.get(storageType.session, "userId");
        this.titlePage = "h_Home";
        this.paperToolbarBackColor = "var(--background-primary)";
        this.paperToolbarTextColor = "var(--primary-dark-color)";
        this.nameFromLiteral = false;
        this.contextualMenu = [{
            href: "/emergency-landing",
            label: "h_emergency_service",
            icon: "emergency-outline"
        }, {
            href: "/mobile-mails-landing",
            label: "h_Mails",
            icon: "mails-outline"
        }, {
            href: "/service-requests-listing",
            label: "h_ServiceRequest",
            icon: "payments-collections"
        }];
        var self = this;
        var prospectIndicator = clientStorage.get(storageType.session, "prospectIndicator");

        this._getOffersCall();

        if (prospectIndicator == "Y") {
            setTimeout(function () {
                self.bills = [];
                self.billers = [];
                self.loansWithAllAccounts = [];
                self.loans = [];
                self.investmentsWithAllAccounts = [];
                self.investments = [];
                self.cardsWithAllAccounts = [];
                self.cards = [];
                self.savingsWithAllAccounts = [];
                self.savings = [];
                self.paymentApproval = [];
            }, 50);
            return;
        }

        // this._getAjaxServiceCall('accounts');

        // Get bills data for 5 days from today
        let date = getNewDate();
        const daysOfBills = 5;
        const billsUrl = "bills?filter[where][dueDate][between][0]=" +
        this.dateParse(getNewDate(date.setDate(date.getDate()))) + "&filter[where][dueDate][between][1]=" + 
        this.dateParse(getNewDate(getNewDate(getNewDate().setDate(getNewDate().getDate() + daysOfBills)).setHours(23,59,59,999))) + "&filter[order]=dueDate DESC";
        this._getAjaxServiceCall(billsUrl);

        this._getAjaxServiceCall('billers');

        //this._getAjaxServiceCall('userpreference'); //this._getOffersCall(); -- Commented for duplicate calls of offer

        this._getAjaxServiceCall('transactionsrequests-approvals?filter[where][transactionStatus]=PMA');

        this._getAjaxTickerMessageServiceCall();
        this.$$("dashboard-quick-links").addEventListener('payTypeEvent', function() {
            self.selectPaymentType();
        })
    },

    dateParse:function(d) {
        return d.toISOString().slice(0, 19);
    },
    /*Get list from ticker messages service call */
    _getAjaxTickerMessageServiceCall: function () {
        var ajaxCall = document.createElement('oe-ajax');
        var self = this;
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/CBUsers/" + self.userId + '/ticker-messages';
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function (event) {
            self.tickerMessageList = event.detail.response;
            self.tickerMessageListAvailable = true;
        });
        ajaxCall.addEventListener('error', function (err) {
            self.errorMessage = "";
            self.errorMessage = err.detail.request.response ? JSON.parse(err.detail.request.response.error.message.channelcontext).status.message[0].messageDesc : "";
        })
        ajaxCall.generateRequest();
    },

    /*Get list for equity*/
    _getAjaxEquityServiceCall: function (urlForId) {
        var ajaxCall = document.createElement('oe-ajax');
        var self = this;
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/CBUsers/" + self.userId + urlForId;
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function (event) {
            self.equity = event.detail.response;
        });
        ajaxCall.addEventListener("error", function (e) {
            self.serviceError(e, urlForId);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },

    /*Function for handling error*/
    serviceError: function (e, accountType) {
        var self = this;

    if (accountType === 'accounts') {

      self.savingsWithAllAccounts = [];
      self.savings = [];
      self.investmentsWithAllAccounts = [];
      self.investments = [];
      self.loansWithAllAccounts = [];
      self.loans = [];
      self.cardsWithAllAccounts = [];
      self.cards = [];
      if (e.detail.request.__data.status === 400) {
        self.noDetailsFlag = true;
        self.errMessage = JSON.parse(e.detail.request.response.error.message.channelcontext).status.message[0].messageDesc;
      }else {
        self.noDetailsFlag = false;
        self.showNodataFetchMsg = true;
      }
    } else if (accountType === 'bills') self.bills = [];else if (accountType === 'billers') self.billers = [];else if (accountType === 'offers') self.offers = [];else if (accountType === 'transactionsrequests-approvals?filter[where][transactionStatus]=PMA') self.paymentApproval = []; //TODO
    // log clientside issues 

    },
    /* Function for creatinf savings list without closed account */
    _createSavingsList: function (list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeSavingAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.savings = tempList;
    },
    /* Function for creatinf loans list without closed account */
    _createLoansList: function (list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeLoanAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.loans = tempList;
    },
    /* Function for creatinf deposit list without closed account */
    _createInvestmentsList: function (list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeDepositAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.investments = tempList;
    },
    /* Function for creatinf cards list without closed account */
    _createCardsList: function (list) {
        var self = this;
        var tempList = [];

        for (var i = 0; i < list.length; i++) {
            if (list[i].accountStatus != undefined && list[i].accountStatus.cmCode != undefined && self.activeCardAccountStatus.indexOf(list[i].accountStatus.cmCode) > -1) {
                tempList.push(list[i]);
            }
        }

        this.cards = tempList;
    },

    /*Get list for bonds holdings*/
    _getAjaxBondServiceCall: function (urlForId) {
        var ajaxCall = document.createElement('oe-ajax');
        var self = this;
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + urlForId;
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function (event) {
            self.bonds = event.detail.response;
        });
        ajaxCall.addEventListener("error", function (e) {
            self.serviceError(e, urlForId);
        });
        ajaxCall.generateRequest();
    },

    selectPaymentType: function () {
        this.$.adhocPaymentType.$$("#paymentType").open();
    },
    _selectcontactCategoryDDA: function (keyboardEvent) {
        if (keyboardEvent.keyCode === 32 || keyboardEvent.keyCode === 13) {
            this.goToAdhocPayment(keyboardEvent);
        }
    },

    goToAdhocPayment: function (e) {
        this.selectedNetwork = e.model.categoryItem;
        this.selecteNetworkCode = this.selectedNetwork.cmCode;
        if (this.selecteNetworkCode == "WIB") {
            window.oe_navigate_to("/adhoc-payment", {
                "selectedPaymentType": this.selecteNetworkCode,
                "adhocNavigationDashboard": true
            });
        }

        if (this.selecteNetworkCode == "ALS") {
            window.oe_navigate_to("/adhoc-payment", {
                "selectedPaymentType": this.selecteNetworkCode,
                "adhocNavigationDashboard": true
            });
        }

        if (this.selecteNetworkCode == "OTH") {
            window.oe_navigate_to("/adhoc-payment", {
                "selectedPaymentType": this.selecteNetworkCode,
                "adhocNavigationDashboard": true
            });
        }

    },
    goToAdhocPaymentDDA: function (e) {
        var indx = e.model.index;

        for (let i = 1; i <= this.ntwklist.length; i++) {
            if (this.shadowRoot.querySelector("#categoryitemIndex_" + i)) {
                this.shadowRoot.querySelector("#categoryitemIndex_" + i).setAttribute("tabindex", "0");
            }
        }

        if (e.keyCode == 32 || e.keyCode == 13) {
            this.goToAdhocPayment(e);

            this.shadowRoot.getElementById('adhocPaymentType')._close();

            setTimeout(function () {
                this.$$("#idSelectedCategory").focus();
            }.bind(this), 200);
        }

        if (e.keyCode === 35) {
            var counts = this.ntwklist.length;
            indx = Number(counts) - 1;

            if (this.shadowRoot.querySelector("#categoryitemIndex_" + indx)) {
                this.shadowRoot.querySelector("#categoryitemIndex_" + indx).focus();
            }
        }

        if (e.keyCode === 36) {
            if (this.shadowRoot.querySelector("#categoryitemIndex_0")) {
                this.shadowRoot.querySelector("#categoryitemIndex_0").focus();
            }
        }

        if (e.keyCode === 39 || e.keyCode === 40) {
            var nums = 0;

            if (e.model.index == this.ntwklist.length - 1) {
                this.shadowRoot.querySelector("#categoryitemIndex_0").focus();
            } else {
                e.currentTarget.nextElementSibling.focus();
                nums = nums + 1;
            }
        } else if (e.keyCode === 37 || e.keyCode === 38) {
            var inx = this.ntwklist.length - 1;

            if (e.model.index == 0) {
                this.shadowRoot.querySelector("#categoryitemIndex_" + Number(inx)).focus();
            } else {
                e.currentTarget.previousElementSibling.focus();
                inx = inx - 1;
            }
        }

        if (e.keyCode == 9) {
            for (let i = 1; i <= this.ntwklist.length; i++) {
                if (this.shadowRoot.querySelector("#categoryitemIndex_" + i)) {
                    this.shadowRoot.querySelector("#categoryitemIndex_" + i).setAttribute("tabindex", "-1");
                }
            }

            setTimeout(function () {
                this.$$("#adhocPaymentType").shadowRoot.getElementById("paymentType").children[0].children[0].children[1].children[1].focus();
            }.bind(this), 0);
        }
    },
    _onFocusIn: function (e) {
        e.currentTarget.setAttribute("style", "outline: 2px solid #0075da");
    },
    _onFocusOut: function (e) {
        e.currentTarget.removeAttribute("style");
    }
});
